import React from 'react';
import { Helmet } from 'react-helmet';
import { Typography, Paper, Divider, Link } from '@mui/material';

function HowToFindLostCertificate() {
  return (
    <Paper sx={{ p: { xs: 2, md: 4 } }}>
      <Helmet>
        <title>పోయిన సర్టిఫికేట్లను తిరిగి పొందడం ఎలా? | Skyrool</title>
        <meta
          name="description"
          content="మీ పోయిన విద్యా సర్టిఫికేట్ లేదా ఇతర ముఖ్యమైన పత్రాలను తిరిగి పొందడానికి స్టెప్-బై-స్టెప్ గైడ్. FIR, పేపర్ ప్రకటన, బోర్డు అప్లికేషన్ వంటి పూర్తి సమాచారం."
        />
        <meta
          name="keywords"
          content="పోయిన సర్టిఫికేట్, డూప్లికేట్ సర్టిఫికేట్, FIR, విద్యా పత్రాలు, పోయిన సర్టిఫికేట్ దొరకడం"
        />
      </Helmet>

      <Typography variant="h3" component="h1" gutterBottom>
        పోయిన సర్టిఫికేట్లను తిరిగి పొందడం ఎలా?
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 2 }}>
        ప్రచురించబడినది: ఆగస్టు 13, 2025
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Typography variant="body1" paragraph>
        మీ ముఖ్యమైన విద్యా లేదా ఇతర సర్టిఫికేట్లు పోవడం చాలా ఆందోళన కలిగించే విషయం. కానీ, చింతించకండి. సరైన ప్రక్రియను అనుసరిస్తే, మీరు వాటి డూప్లికేట్ కాపీలను తిరిగి పొందవచ్చు.
      </Typography>

      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>దశ 1: పోలీసులకు ఫిర్యాదు చేయండి</Typography>
      <Typography variant="body1" paragraph>
        మీ సమీపంలోని పోలీస్ స్టేషన్‌లో FIR (First Information Report) నమోదు చేయండి. డూప్లికేట్ సర్టిఫికేట్ కోసం దరఖాస్తు చేస్తప్పుడు ఇది తప్పనిసరి.
      </Typography>

      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>దశ 2: వార్తాపత్రికలో ప్రకటన ఇవ్వండి</Typography>
      <Typography variant="body1" paragraph>
        స్థానిక ఇంగ్లీష్ మరియు తెలుగు పత్రికలో ప్రకటన ఇవ్వండి. ప్రకటనలో మీ పేరు, సర్టిఫికేట్ వివరాలు, సంప్రదింపు సమాచారం ఉండాలి.
      </Typography>

      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>దశ 3: సంబంధిత బోర్డు/విశ్వవిద్యాలయాన్ని సంప్రదించండి</Typography>
      <Typography variant="body1" paragraph>
        SSC బోర్డు లేదా JNTU వంటి సంబంధిత సంస్థలో డూప్లికేట్ సర్టిఫికేట్ కోసం అప్లై చేయండి.
      </Typography>
      <ul>
        <li>పూర్తి దరఖాస్తు ఫారం</li>
        <li>FIR కాపీ</li>
        <li>వార్తాపత్రిక క్లిప్పింగ్</li>
        <li>అఫిడవిట్</li>
        <li>ID ప్రూఫ్</li>
        <li>ఫీజు రసీదు</li>
      </ul>

      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>దశ 4: మా వెబ్‌సైట్‌లో పోస్ట్ చేయండి</Typography>
      <Typography variant="body1" paragraph>
        మీ పోయిన సర్టిఫికేట్ గురించి <Link href="https://find.skyrool.com/lost" target="_blank">Skyrool Lost & Found</Link>లో పోస్ట్ చేయండి.
      </Typography>
    </Paper>
  );
}

export default HowToFindLostCertificate;
